module.exports = "/_next/static/images/lb-bc789b21fd21dd46a518649b0f8f9712.svg";